import React from 'react';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class UserAttributes extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSexChange = (new_value) => {
        this.props.onSexChange(new_value);
    }

    handleAgeChange = (new_value) => {
        this.props.onAgeChange(new_value);
    }

    handleLifeActivityIntensityChange = (new_value) => {
        this.props.onLifeActivityIntensityChange(new_value);
    }

    render() {
        return (
            <div className={`user-attributes-flex ${this.props.className ?? ''}`}>
                <h1 className="bb-1px-solid">性別</h1>
                <div className="select-group">
                    <div className={this.props.user_attributes.sex === 1 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleSexChange(1)}>
                        {
                            this.props.user_attributes.sex === 1 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.sex !== 1 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">男性</div>
                    </div>
                    <div className={this.props.user_attributes.sex === 2 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleSexChange(2)}>
                        {
                            this.props.user_attributes.sex === 2 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.sex !== 2 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">女性</div>
                    </div>
                </div>
                <h1 className="bb-1px-solid">年齢</h1>
                <div className="select-group">
                    <div className={this.props.user_attributes.age === 18 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleAgeChange(18)}>
                        {
                            this.props.user_attributes.age === 18 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.age !== 18 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">18～29歳</div>
                    </div>
                    <div className={this.props.user_attributes.age === 30 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleAgeChange(30)}>
                        {
                            this.props.user_attributes.age === 30 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.age !== 30 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">30～49歳</div>
                    </div>
                    <div className={this.props.user_attributes.age === 50 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleAgeChange(50)}>
                        {
                            this.props.user_attributes.age === 50 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.age !== 50 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">50～64歳</div>
                    </div>
                    <div className={this.props.user_attributes.age === 65 ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleAgeChange(65)}>
                        {
                            this.props.user_attributes.age === 65 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.age !== 65 &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">65～74歳</div>
                    </div>
                </div>
                <h1 className="bb-1px-solid">身体活動レベル</h1>
                <div className="select-group">
                    <div className={this.props.user_attributes.life_activity_intensity === 1 ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleLifeActivityIntensityChange(1)}>
                        {
                            this.props.user_attributes.life_activity_intensity === 1 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.life_activity_intensity !== 1 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-1-2">低い（ほぼ１日、座って過ごしている）</div>
                    </div>
                    <div className={this.props.user_attributes.life_activity_intensity === 2 ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleLifeActivityIntensityChange(2)}>
                        {
                            this.props.user_attributes.life_activity_intensity === 2 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.life_activity_intensity !== 2 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-1-2">ふつう（基本デスクワーク、通勤移動などの運動のみ）</div>
                    </div>
                    <div className={this.props.user_attributes.life_activity_intensity === 3 ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleLifeActivityIntensityChange(3)}>
                        {
                            this.props.user_attributes.life_activity_intensity === 3 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.user_attributes.life_activity_intensity !== 3 &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-1-2">高い（移動や立った状態での労働、活発な運動をする）</div>
                    </div>
                </div>
            </div>
        );
    }
}